import React from "react";
import * as storeService from "../addRuleStoreService";
import { connect } from "react-redux";


function EnableSystemRemediationField({ value, ruleKey, rule, disabled }) {

    const onChange = (value) => {
        storeService.changeRule({ ...rule, [ruleKey]: value })
    }

    return (
        <label className="addrules-checkbox-item-v2">
            <input
                type="checkbox"
                checked={!!value}
                disabled={disabled}
                onChange={() => {
                    onChange(!value);
                }}
            />
            <span className="checkbox-label">Enable Automatic System Remediation</span>
        </label>
    )

}

// export default EnableSystemRemediationField;

// function mapStateToProps(state) {
//     debug("EnablePasswordField mapStateToProps", state);
//     const addDeviceModal = state.addDeviceModal;
//     return {
//         enableRemediation: addDeviceModal.enableRemediation || ''
//     }
// }

function mapStateToProps(state) {

    return {
        rule: state.addRulesPage.rule || {}
    }

}

export default connect(mapStateToProps)(EnableSystemRemediationField);
